import { render, staticRenderFns } from "./menu-list.vue?vue&type=template&id=280b55cf"
import script from "./menu-list.vue?vue&type=script&lang=js"
export * from "./menu-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports